import EventBus from '../../../../shared/js/wirebox/event-bus'
import jQuery from 'jquery'
import {default as Bookmarks} from './bookmarks'
import Archive from '../archive'

class FundersList extends Archive {
    
    /**
     * Construct component
     * @param container
    */
    constructor(container) {
        
        super({
            container: container,
            countText: jQuery('#funders-count'),
            descending: false,
            filterForm: jQuery('#funder-filters'),
            key: 'funders-list',
            template: jQuery('#funder-template'),
            updatedTime: fundersUpdatedTime
        })
        
        /**
         * Character number formats
         * @type object
        */
        this.numberFormats = {
            k: '000',
            m: '000000'
        }
        
        //Set "this" bindings on events
        this.handleScroll = this.handleScroll.bind(this)
        
        this.bindEvents()
        
    }
    
    /**
     * Render Funders
     * @param items
    */
    renderItems(items) {
        
        let
            elem,
            entities,
            url,
            bookmark
        
        //Loop through items
        jQuery.each(items, (i, funder) => {
            
            elem = jQuery(this.templateHtml)
            entities = this.mapEntities(funder)
            url = funderUrl.replace('-1', funder.slug)
            
            //Apply funder name
            elem.find('.funder-name').html(`<a target="_blank" href="${url}">${funder.name}</a>`)
            
            //Apply funder type
            this.addTemplateEntity(elem, entities, '.funder-type', 'type_of_funder')
            
            //Apply funding type
            this.addTemplateEntity(elem, entities, '.funding-type', 'type_of_funding')
            
            //Apply size of investments
            this.addTemplateEntity(elem, entities, '.investment-size', 'size_of_investments', this.arrayToNumericString.bind(this))

            //Apply geographic area
            this.addTemplateEntity(elem, entities, '.geo-area', 'area_of_interest')
            
            //Apply ocean topics
            this.addTemplateEntity(elem, entities, '.ocean-topics', 'ocean_action_areas', this.removeParenthesis.bind(this))
            
            //Apply eligible recipient
            this.addTemplateEntity(elem, entities, '.recipient', 'type_of_recipient')
            
            //Apply project activity
            this.addTemplateEntity(elem, entities, '.activity', 'project_activity_focus')
            
            //Apply ID to bookmark button / hide bookmark if not logged in
            bookmark = elem.find('.bookmark')
            if (isLoggedIn) {
                bookmark.data('slug', funder.slug)
                this.updateBookmarkBtn(bookmark, Bookmarks.has(funder.id))
            }
            else {
                bookmark.remove()
            }
            
            //Apply info URL
            elem.find('.more-info').attr('href', url)
            
            //Append element to archive
            this.container.append(elem)
            
        })
        
    }
    
    /**
     * Map entities
     * @param funder
     * @return object
    */
    mapEntities(funder) {
        
        const map = {}
        
        //Loop through funder entities
        jQuery.each(funder.entities, (i, entity) => {
            
            //Initialise values array if empty
            if (!map.hasOwnProperty(entity.type.name)) {
                map[entity.type.name] = []
            }
            
            //Push values to array
            map[entity.type.name].push(entity.name)
            
        })
        
        return map
        
    }
    
    /**
     * Add template entity
     * @param elem
     * @param selector
     * @param key
     * @param formatter
    */
    addTemplateEntity(elem, entities, selector, key, formatter = null) {
        if (entities.hasOwnProperty(key)) {
            elem.find(selector).text(formatter ? formatter(entities[key]) : this.arrayToString(entities[key]))
        }
        else {
            elem.find(selector).parent().remove()
        }
    }
    
    /**
     * Convert array to string
     * @param array
     * @return string
    */
    arrayToString(array) {
        return array.join(', ')
    }
    
    /**
     * Convert array to numeric string
     * @param array
     * @return string
    */
    arrayToNumericString(array) {
        
        //Initialise array for sorting
        const items = []
        
        //Loop through array & populate items
        
        let
            tokens,
            start
            
        jQuery.each(array, (i, text) => {
            
            tokens = text.split('-')
            start = tokens[0].replace('+', '').trim()
            
            //Loop through number formats & replace characters with zeros
            jQuery.each(this.numberFormats, (char, zeros) => {
                start = start.replace(char, zeros)
            })

            //Add item to array with sortable number
            items.push({
                text: text,
                value: parseInt(start)
            })
            
        })
        
        //Sort items
        items.sort((a, b) => {
            return a.value - b.value
        })
        
        //Convert items to string
        
        var string = ''
        
        jQuery.each(items, (i, item) => {
            string += (i ? ', ' : '') + item.text
        })
        
        return string
        
    }
    
    /**
     * Bookmark click
     * @param event
    */
    bookmarkClick(event) {
        
        const
            clicked = jQuery(event.currentTarget),
            url = bookmarkUrl.replace('-1', clicked.data('slug'))
            
        //Show loading animation on button
        EventBus.publish('loading.start', clicked)
        
        //Post request to server
        jQuery.post(url, (response) => {
            this.updateBookmarkBtn(clicked, response.bookmarked)
        }).always(() => {
            EventBus.publish('loading.stop', clicked)
        })
        
    }
    
    /**
     * Update bookmark button
     * @param element
     * @param bookmarked
    */
    updateBookmarkBtn(element, bookmarked) {
        if (bookmarked) {
            element.text('Bookmarked').addClass('bg-secondary')
        }
        else {
            element.text('Bookmark this fund').removeClass('bg-secondary')
        }
    }
    
    /**
     * Remove text in parenthesis from array of strings
     * @param array
     * @return string
    */
    removeParenthesis(array) {
        return this.arrayToString(array).replace(/ *\([^)]*\) */g, '')
    }
    
    /**
     * Bind events
    */
    bindEvents() {
        
        //Bind map created event
        EventBus.subscribe('run-modules', this.run.bind(this))
        
        //Bind filter form submit event
        this.filterForm.submit(this.handleFilters.bind(this))
        
        //Bind sort order button click event
        jQuery('#funders-order-btn').click(this.handleOrdering.bind(this))
        
        //Bind bookmark button click event
        this.container.on('click', '.bookmark', this.bookmarkClick.bind(this))
        
        //Bind filter events
        this.bindFilterEvents()
        
    }
    
}

EventBus.subscribe('init-modules',  () => {
    
    const container = jQuery('#funders-list')
    
    if (container.length > 0) {
        new FundersList(container)
    }
    
})

export default FundersList